/* istanbul ignore file */
import React from 'react';
import { EnumDropdown } from 'framework/form';

const ASSIGNMENT_LANGUAGE = {
  ENGLISH: 'English',
};

// Check AssessmentItem if some add
const AssignmentLanguageDropdown = (props: any) => {
  return <EnumDropdown {...props} options={ASSIGNMENT_LANGUAGE} placeholder="Select Language" />;
};

export default AssignmentLanguageDropdown;
